/**
 * @ngdoc service
 * @name drupal
 *
 * @description Drupal api service.
 */
module.factory('drupal', function ($http, $document, $timeout, lodash, $q) {

    const retrieveToken = '/session/token';

    function extractData(response) {
            return response.data;
        }

        var defaultOptions = {
            params: {
                _format: 'json'
            }
        };

        // Doesn't handle options and data right now, might be added later
        function requestDrupal(url) {
            return $http.get(url, defaultOptions).then(extractData);
        }

        // Doesn't handle invalidation, options & data right now, might be added later
        function cachedRequest(url) {
            var request;
            return function () {
                if (!request) {
                    request = requestDrupal(url);
                }

                return request;
            }
        }

        function oneAtATime(fn) {
            var promise = null;

            return function () {
                if (!promise) {
                    promise = fn.apply(null, arguments).finally(function () {
                        promise = null;
                    });
                }

                return promise;
            }
        }

        return {
            retrieveOrder: function (id) {
                return $http.get('/api/order/' + id, {params: {'_format': 'json'}}).then(function (result) {
                    return result.data
                });
            },
            checkEmail: function (email) {
                return $timeout(function () {
                    return $http.get('themes/custom/aqua/src/views/member/models/email_validation.json').then(function (result) {
                        return result.data;
                    });
                }, 1000);
            },
            retrieveProfile: oneAtATime(function () {
                return $http.get('/api/connected_user', {params: {'_format': 'json'}}).then(function (user) {
                    return user.data;
                });
            }),
            releaseProfile: function () {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.get('/api/logout', {
                        params: {'_format': 'json'},
                        headers: {'X-CSRF-Token': session.data}
                    });
                });
            },
            authenticate: function (credentials) {
                return $http.post('/user/login', credentials, {params: {'_format': 'json'}});
            },
            getThemePath: function () {
                return angular.element('<a>').prop('href', angular.element(document.querySelector('script:not([async])'))[0].src)[0].pathname.match(/.*\//)[0];
            },
            getResourcePath: function (uri) {
                if (uri.match(/(\/sites\/)/)) {
                    return window.location.protocol + '//' + window.location.host;
                } else {
                    return this.getThemePath();
                }
            },
            getConfig: function (config) {
                return $http.get('/' + config, {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getNationalities: function () {
                return $http.get('/api/nationality', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getNodes: function (types) {
                return $http.get('api/node', {
                    params: {
                        'type[]': types || [],
                        '_format': 'json'
                    }
                }).then(function (response) {
                    return response.data;
                });
            },
            getNode: function (id) {
                return $http.get('node/' + id, {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getPage: function (id) {
                return $http.get('api/node', {params: {'identifier': id, '_format': 'json'}}).then(function (response) {
                    return response.data.length > 0 ? response.data[0] : null;
                });
            },
            createDonation: function (data) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.post('/entity/donation', data, {
                        params: {'_format': 'json'},
                        headers: {'X-CSRF-Token': session.data}
                    });
                });
            },
            getPayboxUrl: function (data) {
                return $http.get('/payment/' + data.reference, {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getCriteria: function () {
                return $http.get('/api/criteria', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getAllInternships: cachedRequest('/api/internship'),
            getAllSimpleInternships: cachedRequest('/api/simple-internship'),
            getThemes: cachedRequest('/api/themes'),
            getInternships: function (productId) {
                return $http.get('/api/internship', {
                    params: {
                        '_format': 'json',
                        productId: productId
                    }
                }).then(function (response) {
                    return response.data;
                });
            },
            getInternship: function (internshipId) {
                return $http.get('/api/internship', {
                    params: {
                        '_format': 'json',
                        internshipId: internshipId
                    }
                }).then(function (response) {
                    return response.data;
                });
            },
            getInternshipsSupervised: function () {
                return $http.get('api/internships_supervised', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getProduct: function (productId) {
                return $http.get('/api/product', {
                    params: {
                        '_format': 'json',
                        productId: productId
                    }
                }).then(function (response) {
                    return response.data[0];
                });
            },
            getProductRelated: function (productId, stageId) {
                return $http.get('/api/product/' + productId + '/related/' + stageId, {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getProducts: function () {
                return $http.get('/api/product', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getStage: function (stageId) {
                return $http.get('/api/stage/' + stageId, {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                })
            },
            createAccount: function (data) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.post('/api/account', data, {
                        params: {'_format': 'json'},
                        headers: {'X-CSRF-Token': session.data}
                    });
                }).then(function (user) {
                    return user.data;
                });
            },
            updateAccount: function (id, infos) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.patch('/api/account/' + id, infos, {
                        params: {'_format': 'json'},
                        headers: {'X-CSRF-Token': session.data}
                    });
                }).then(function (result) {
                    return result.data;
                });
            },
            uploadAccountFile: function (id, file) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.post('/api/account/' + id + '/file', file, {
                        params: {'_format': 'json'},
                        headers: {'X-CSRF-Token': session.data}
                    });
                }).then(function () {
                    return {};
                });
            },
            getAccountResume: function (id) {
                return $http.get('/api/account/' + id + '/resume', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getAccountGraduation: function (id) {
                return $http.get('/api/account/' + id + '/graduation', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getAccountOrders: function (id) {
                return $http.get('/api/account/' + id + '/order', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getMembershipOrders: function () {
                return $http.get('/api/product/membershipfee', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getAccountFiles: function (id) {
                return $http.get('/api/account/' + id + '/file', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getAccountByMemberId: function (id, lastname) {
                return $http.get('/api/account', {
                    params: {
                        '_format': 'json',
                        'memberId': id,
                        'lastName': lastname
                    }
                }).then(function (response) {
                    return response.data.length > 0 ? response.data[0] : null;
                });
            },
            getAccountsByEmail: function (email) {
                return $http.get('/api/account', {params: {'_format': 'json', 'email': email}}).then(function (response) {
                    return response.data;
                });
            },
            retrievePassword: function (username) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.delete('/api/password', {
                        params: {'_format': 'json', 'username': username},
                        headers: {'X-CSRF-Token': session.data}
                    });
                }).then(function (result) {
                    return {status: "OK"};
                });
            },
            subsbribeNewletter: function (email) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.post('/api/newsletter', {'email': email}, {
                        params: {'_format': 'json'},
                        headers: {'X-CSRF-Token': session.data}
                    });
                }).then(function (result) {
                    return {status: "OK"};
                });
            },
            subscribeCatalog: function (data) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.post('/api/catalog', data, {
                        params: {'_format': 'json'},
                        headers: {'X-CSRF-Token': session.data}
                    });
                }).then(function (result) {
                    return {status: "OK"};
                });
            },
            sendCart: oneAtATime(function (cart) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.patch('/api/cart', cart, {
                        params: {'_format': 'json'},
                        headers: {'X-CSRF-Token': session.data}
                    });
                }).then(function (result) {
                    if (typeof result.data.orderLines === 'undefined') {
                        var defered = $q.defer();
                        defered.reject(result.data);
                        return defered.promise;
                    } else {
                        return result.data;
                    }
                });
            }),
            getCart: function () {
                return $http.get('/api/cart', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            applyCoupon: function (code) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.post('/api/cart/promo', {code: code}, {
                        params: {'_format': 'json'},
                        headers: {'X-CSRF-Token': session.data}
                    }).then(function (response) {
                        return response.data;
                    });
                });
            },
            soldPaybox: function (order, amount, context, id_session) {
                id_session = typeof id_session === 'undefined' ? false : id_session;
                return $http.get(retrieveToken).then(function (session) {
                    return $http.post('/api/order/pay', {
                        sfid: order.sfid,
                        sold: amount,
                        card: order.card.number,
                        validity: order.card.month + order.card.year,
                        cvv: order.card.code,
                        arrivalTimeOnPayPage: order.arrivalTimeOnPayPage,
                        id_session: id_session
                    }, {
                        params: {'_format': 'json', 'context': context}, headers: {'X-CSRF-Token': session.data}
                    }).then(function (response) {
                        return response.data;
                    });
                });
            },
            getRemoteMPIValues: function (order, amount, mpi_origin, totalQuantity) {
                console.log(totalQuantity);
                return $http.get(retrieveToken).then(function (session) {
                    return $http.post("/api/order/mpi", {
                        sfid: order.sfid,
                        sold: amount,
                        card: order.card.number,
                        validity: order.card.month + order.card.year,
                        cvv: order.card.code,
                        mpi_origin: mpi_origin,
                        totalQuantity: totalQuantity
                    }, {
                        params: {'_format': 'json'}, headers: {'X-CSRF-Token': session.data}
                    }).then(function (response) {
                        return response.data;
                    });
                });
            },
            capturePaybox: function (order, id_session) {
                id_session = typeof id_session === 'undefined' ? false : id_session;
                return $http.get(retrieveToken).then(function (session) {
                    return $http.post('/api/order/capture', {
                        sfid: order.sfid,
                        sold: order.caution,
                        card: order.card.number,
                        validity: order.card.month + order.card.year,
                        cvv: order.card.code,
                        arrivalTimeOnPayPage: order.arrivalTimeOnPayPage,
                        id_session: id_session
                    }, {
                        params: {'_format': 'json'}, headers: {'X-CSRF-Token': session.data}
                    }).then(function (response) {
                        return response.data;
                    });
                });
            },
            updateOpportunityStatus: function (order) {
                console.log(order.paymentChoice, order.registerType);
                var amount = 0;
                var url = '';

                if (order.registerType === 'advance') {
                    amount = order.deposit;
                } else {
                    amount = order.field_total_amount;
                }

                // Build params URL.
                url = order.sfid + '/' + amount + '/' + order.paymentChoice + '/' + order.registerType;

                return $http.get(retrieveToken).then(function (session) {
                    return $http.patch('/api/opportunity/status/' + url, {}, {
                        params: {'_format': 'json'}, headers: {'X-CSRF-Token': session.data}
                    }).then(function (response) {
                        return response.data;
                    });
                });
            },
            bookingCommand: function (order) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.patch('/api/cart/' + order.sfid + '/Réservation', {}, {
                        params: {'_format': 'json'},
                        headers: {'X-CSRF-Token': session.data}
                    })
                }).then(function (response) {
                    return response.data;
                });
            },
            getTraining: function () {
                return $http.get('/api/trainings', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getTrainingDomaine: function () {
                return $http.get('/api/trainings_domaine', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getLevelsUser: function () {
                return $http.get('/api/level/user', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            /* evaluations */
            getParticipations: function () {
                return $http.get('/api/participations', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getParticipationsRTQ: function () {
                return $http.get('/api/participations/rtq', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getPrerequisites: function (participationId) {
                return $http.get('/api/prerequisites', {
                    params: {
                        '_format': 'json',
                        participationId: participationId
                    }
                }).then(function (response) {
                    return response.data;
                });
            },
            getIntern: function (participationId, canceler) {
                return $http.get('/api/interns', {
                    timeout: canceler.promise,
                    params: {'_format': 'json', participationId: participationId}
                }).then(function (response) {
                    return response.data;
                });
            },
            updateIntern: function (internshipId, data) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.patch('/api/interns', data, {
                        params: {'_format': 'json'},
                        headers: {'X-CSRF-Token': session.data}
                    }).then(function (response) {
                        return response.data;
                    });
                });
            },
            getInterns: function (internshipId) {
                return $http.get('/api/interns', {
                    params: {
                        '_format': 'json',
                        internshipId: internshipId
                    }
                }).then(function (response) {
                    return response.data;
                });
            },
            getLevels: function (participationId, noFoil) {
                var params = {
                    '_format': 'json',
                    participationId: participationId
                }
                if (noFoil) {
                    params.noFoil = noFoil;
                }
                return $http.get('/api/levels', {
                    params: params
                }).then(function (response) {
                    return response.data;
                });
            },
            getNiveaux: function (filiereId) {
                return $http.get('/api/niveaux', {
                    params: {
                        '_format': 'json',
                        filiereId: filiereId
                    }
                }).then(function (response) {
                    return response.data;
                });
            },
            confirmLevel: function (data) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.patch('/api/levels', data, {headers: {'X-CSRF-Token': session.data}}).then(function (response) {
                        return response.data;
                    });
                });
            },
            getCompetencies: function (participationId, levelId, noFoil) {
                var params = {
                    '_format': 'json',
                    participationId: participationId,
                    levelId: levelId
                }
                if (noFoil) {
                    params.noFoil = noFoil;
                }
                return $http.get('/api/competencies', {
                    params: params
                }).then(function (response) {
                    return response.data;
                });
            },
            getCompetenciesNiveau: function (participationId, levelId, noFoil) {
                var params = {
                    '_format': 'json',
                    participationId: participationId,
                    levelId: levelId
                }
                if (noFoil) {
                    params.noFoil = noFoil;
                }
                return $http.get('/api/competencies_niveau', {
                    params: params
                }).then(function (response) {
                    return response.data;
                });
            },
            updateCompetency: function (data) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.patch('/api/competencies', data, {
                        params: {'_format': 'json'},
                        headers: {'X-CSRF-Token': session.data}
                    }).then(function (response) {
                        return response.data;
                    });
                });
            },
            finishEvaluation: function (participationId) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.patch('/api/finished_evaluation', {participationId: participationId}, {headers: {'X-CSRF-Token': session.data}}).then(function (response) {
                        return response.data;
                    });
                });
            },
            getPreconisation: function (participationId) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.get('/api/recommendation', {
                        params: {
                            '_format': 'json',
                            participationId: participationId
                        }
                    }).then(function (response) {
                        return response.data;
                    });
                });
            },
            updatePreconisation: function (data) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.patch('/api/recommendation', data, {
                        params: {'_format': 'json'},
                        headers: {'X-CSRF-Token': session.data}
                    }).then(function (response) {
                        return response.data;
                    });
                });
            },
            getEvaluations: function () {
                return $http.get('/api/evaluations', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            /* assessments */
            getCourses: function () {
                return $http.get('/api/courses', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getFeedback: function (internshipId) {
                return $http.get('/api/feedback', {
                    params: {
                        '_format': 'json',
                        internshipId: internshipId
                    }
                }).then(function (response) {
                    return response.data;
                });
            },
            getSupervisedInternships: function () {
                return $timeout(function () {
                    return $http.get('themes/custom/aqua/src/views/member/models/internship_supervised.json').then(function (response) {
                        return response.data;
                    });
                }, 1000);
            },
            checkToken: function (uid, tmstp, token) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.get('/api/password', {
                        params: {'_format': 'json', 'uid': uid, 'timestamp': tmstp, 'token': token},
                        headers: {'X-CSRF-Token': session.data}
                    });
                }).then(function (response) {
                    return response.data;
                });
            },
            changePassword: function (params) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.post('/api/password', {
                        params: {'_format': 'json', 'params': params},
                        headers: {'X-CSRF-Token': session.data}
                    });
                }).then(function (response) {
                    if (response.status === "200") {
                        return {status: "OK"};
                    } else {
                        return {status: response.status};
                    }
                });
            },
            getItalianPopinTranslation: function () {
                return $http.get('/api/italian_popin', {params: {'_format': 'json'}}).then(function (response) {
                    return response.data;
                });
            },
            getNews: function (page, itemsPerPage, site) {
                return $http.get('/api/news', {
                    params: {
                        _format: 'json',
                        page: page || 0,
                        items_per_page: itemsPerPage,
                        site: site
                    }
                }).then(function (response) {
                    return response.data;
                });
            },
            validateAllCompetencies: function (level, internshipId) {
                return $http.get(retrieveToken).then(function (session) {
                    return $http.post('/api/competencies/validate/all', {'level': level, 'internshipId': internshipId}, {
                        params: {'_format': 'json'},
                        headers: {'X-CSRF-Token': session.data}
                    });
                }).then(function (result) {
                    return {status: "OK"};
                });
            }
        }
    }
);
